import React, { useEffect, useState } from "react";

import img1 from "../../media/images/bor-pet.png";
import LoadingComponent from "../LoadingComponent";
import { useNavigate } from "react-router-dom";

const BookingForm = ({ setOpenForm }) => {
  //----------------------form  ----------------------------------

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const pageFullUrl = window.location.href;
  const [error, setError] = useState(null);

  const [data, setData] = useState({
    pet: "",
    name: "",
    phone: "",
    service: "",
    addOns: "",
    breed: "",
    address: "",
    request: "",
    user: "true",
    status: "true",

    path: pageFullUrl,
  });

  const handleChange = (e) => {
    const value = e.target.value;
    setData({
      ...data,
      [e.target.name]: value,
    });
  };

  const handleNumber = (e) => {
    const value = e.target.value;
    setError(null);

    if (value.length <= 10) {
      setData({
        ...data,
        phone: value,
      });
    }
  };

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const [userAgent, setUserAgent] = useState("");
  const [ipAddress, setIpAddress] = useState(null);

  const getIp = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");

      if (response.ok) {
        const res = await response.json();
        setIpAddress(res.ip);
      } else {
        console.log(false);
      }
    } catch (error) {
      console.log("error in getting few details");
    }
  };

  useEffect(() => {
    getIp();
    setUserAgent(navigator.userAgent);
  }, []);

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const updatedData = {
    remoteIP: ipAddress,
    userAgent: userAgent,
  };

  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const link = process.env.REACT_APP_API_URL;

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  };

  const handleSubmit = async (e) => {
    setLoading(true);

    e.preventDefault();

    if (data.phone.length != 10) {
      setError("enter the valid number");
    } else {
      const filledDate = localStorage.getItem("formFilledDate");
      const today = getTodayDate();
      if (filledDate === today) {
        setError(
          "You've already filled out the form. Please try calling us now."
        );
      } else {
        try {
          const response = await fetch(`${link}/booking-form`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ ...updatedData, ...data }),
          });

          if (response.ok) {
            localStorage.setItem("formFilledDate", today);
            navigate("/thank-you");
          } else {
            const res_data = await response.json();
            setError(res_data.message);
          }
        } catch (error) {
          setError("server error");
        }
      }
    }

    setLoading(false);
  };

  // ------------------------------------------------------

  return (
    <div>
      {loading ? (
        <div className="data-loading">
          <LoadingComponent />
        </div>
      ) : (
        ""
      )}
      <div className="groom-book-main">
        <div className="groom-book">
          <div className="groom-book-border-img">
            <img src={img1} alt="" />
          </div>
          <div className="groom-book-form">
            <div className="groom-book-form-img">
              {/* <img src={img} alt="img" /> */}
            </div>

            <div className="groom-book-form-content">
              <div className="groom-book-form-content-head">
                <div className="groom-book-form-content-head-col">
                  <div className="groom-book-form-content-head-heading-2">
                    Book Appointment For Your Pet
                  </div>
                </div>

                <div className="groom-book-form-content-head-col">
                  <button
                    onClick={(e) => {
                      setOpenForm(false);
                    }}
                  >
                    <i class="fa-solid fa-circle-xmark"></i>
                  </button>
                </div>
              </div>

              {/* <div className="groom-book-form-content-head-points">
                <div>
                  <img src={van} />
                  We do not offer Van Services.
                </div>
                <div>
                  <img src={towel} />
                  Towel must be provided by customer.
                </div>
              </div> */}

              <div className="groom-book-form-content-form">
                <form onSubmit={handleSubmit}>
                  <div className="groom-book-form-content-form-col1">
                    <label>Your Pet*</label>
                    <div className="groom-book-form-content-form-col1-inp">
                      <div className="groom-book-form-content-form-col1-inp-1">
                        <input
                          required
                          type="radio"
                          name="pet"
                          onChange={handleChange}
                          value="Dog"
                        />
                        <span>DOG</span>
                      </div>
                      <div className="groom-book-form-content-form-col1-inp-1">
                        <input
                          required
                          type="radio"
                          name="pet"
                          onChange={handleChange}
                          value="Cat"
                        />
                        <span>CAT</span>
                      </div>
                    </div>
                  </div>

                  <div className="groom-book-form-content-form-col2">
                    <div className="groom-book-form-content-form-col2-col">
                      <label>Name*</label>
                      <input
                        required
                        type="text"
                        placeholder="Pet Parent Name *"
                        name="name"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="groom-book-form-content-form-col2-col">
                      <label>Phone*</label>
                      <input
                        required
                        onChange={handleNumber}
                        value={data.phone}
                        name="phone"
                        type="number"
                        placeholder="Phone Nmber *"
                      />
                    </div>
                  </div>

                  <div className="groom-book-form-content-form-col3">
                    <label>Interested in*</label>
                    <select
                      required
                      name="service"
                      onChange={handleChange}
                      id=""
                    >
                      <option disabled selected value="">
                        --- Select Service ---
                      </option>

                      {/* <option value="BARK 'N BATH">BARK 'N BATH &nbsp; - &nbsp; Rs. 599/-</option>
                      <option value="PAMPER PAWS">PAMPER PAWS &nbsp; - &nbsp; Rs. 799/-</option> */}
                      <option value="FUR FRESH SPA">
                        FUR FRESH SPA &nbsp; - &nbsp; Rs. 999/-
                      </option>
                      <option value="BASIC GROOMING">
                        BASIC GROOMING &nbsp; - &nbsp; Rs. 1299/-
                      </option>
                      <option value="FULL BODY GROOMING">
                        FULL BODY GROOMING &nbsp; - &nbsp; Rs. 1799/-
                      </option>
                      <option value="DELUXE BODY GROOMING">
                        DELUXE BODY GROOMING &nbsp; - &nbsp; Rs. 2399/-
                      </option>
                      {/* <option value="DAY BOARDING">DAY BOARDING &nbsp; - &nbsp; Rs. 499/-</option>
                      <option value="PER DAY BOARDING">PER DAY BOARDING&nbsp; - &nbsp; Rs. 699/-</option> */}

                      {/* <option value="SILVER PLAN">SILVER PLAN &nbsp; - &nbsp; Rs. 3,999/-</option>
                      <option value="GOLD PLAN">GOLD PLAN &nbsp; - &nbsp; Rs. 6,999/-</option>
                      <option value="DIAMOND PLAN">DIAMOND PLAN &nbsp; - &nbsp; Rs. 11,999/-</option>
                      <option value="PLATINUM">PLATINUM &nbsp; - &nbsp; Rs. 29,999/-</option>
                      <option value="BLACK PLAN">BLACK PLAN &nbsp; - &nbsp; Rs. 99,999/-</option>
                      <option value="DOG HAIR TRIMMING">HAIR TRIMMING &nbsp; - &nbsp; Rs. 999/-</option>
                      <option value="DOG DESIGNER HAIR CUTTING">DESIGNER HAIR CUTTING &nbsp; - &nbsp; Rs. 1,399/-</option> */}

                      {/* <option value="Pet Training">Pet Training</option> */}
                    </select>
                  </div>

                  <div className="groom-book-form-content-form-col4">
                    <label>Any Add-ons</label>
                    <select name="addOns" onChange={handleChange}>
                      <option disabled selected>
                        --- Any Add-Ons ---{" "}
                      </option>
                      <option value="No Add-Ons">No Add-Ons</option>
                      <option value="Tick Removal by Hand">
                        Tick Removal by Hand &nbsp; - &nbsp; Rs 249
                      </option>
                      <option value="30 Min DeStressing Massage">
                        30 Min DeStressing Massage &nbsp; - &nbsp; Rs 349
                      </option>
                      <option value="DeMatting">
                        DeMatting &nbsp; - &nbsp; Rs 249
                      </option>

                      <option value="Ear & Eyes Cleaning">
                        Ear & Eyes Cleaning &nbsp; - &nbsp; Rs 199
                      </option>
                      <option value="Nail's Clipping">
                        Nail's Clipping &nbsp; - &nbsp; Rs 249
                      </option>
                    </select>
                  </div>

                  <div className="groom-book-form-content-form-col5">
                    <label>Breed*</label>
                    <input
                      required
                      placeholder="What's Your Pet Breed *"
                      name="breed"
                      onChange={handleChange}
                    ></input>
                  </div>

                  <div className="groom-book-form-content-form-col5">
                    <label>Address*</label>
                    <input
                      required
                      placeholder="Your Address *"
                      rows="1"
                      name="address"
                      onChange={handleChange}
                    ></input>
                  </div>

                  <div className="groom-book-form-content-form-col5">
                    <label>Special Request</label>
                    <textarea
                      placeholder="Any Special Request"
                      rows="1"
                      name="request"
                      onChange={handleChange}
                    ></textarea>
                    {/* <input type="text" placeholder="message or request" name="" id="" /> */}
                  </div>

                  {error ? (
                    <div className="groom-book-form-content-form-error">
                      {error}
                    </div>
                  ) : (
                    ""
                  )}
                  <button>Book Now</button>
                </form>

                {/* <form>
                <div className="groom-book-form-col">
                  <div className="groom-book-form-col-title">Your Pet *</div>
                  <div className="groom-book-form-col-options">
                    <input type="radio" name="pet" id="" />
                    <label>DOG</label>
                    <input type="radio" name="pet" id="" />
                    <label>CAT</label>
                  </div>
                </div>
                <div className="groom-book-form-col">
                  <input type="number" placeholder="enter your number" />
                  <input type="text" placeholder="enter your name" />
                </div>
                <div className="groom-book-form-col">
                  <div className="groom-book-form-title">Interested In</div>
                  <div className="groom-book-form-option">
                    <select name="" id="">
                      <option disabled selected>
                        --- select service ---
                      </option>
                      <option>PAMPER PAWS</option>
                      <option>FUR FRESH SPA</option>
                      <option>BASIC GROOMING</option>
                      <option>FULL BODY GROOMING</option>
                      <option>DELUXE BODY GROOMING</option>
                    </select>
                  </div>
                </div>

                <div className="groom-book-form-col">
                  <div className="groom-book-form-title">Any Add-ons</div>
                  <div className="groom-book-form-option">
                    <select name="" id="">
                      <option disabled selected>
                        {" "}
                        --- Any Add-Ons ---
                      </option>
                      <option>Tick Removal by Hand</option>
                      <option>30 Min DeStressing Massage</option>
                      <option>DeMatting</option>
                    </select>
                  </div>
                </div>

                <div className="groom-book-form-col">
                  <input
                    type="text"
                    placeholder="any message !"
                    name=""
                    id=""
                  />
                </div>
                <button>Book Now</button>
              </form> */}
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
};

export default BookingForm;
